// Studyo Today Backend
// Package studyo.today.schools.v1.resources
// Resource definitions
// Copyright (c) 2015-2023 Intuitic Inc.

// @generated by protoc-gen-es v2.2.5 with parameter "import_extension=js"
// @generated from file studyo/today/schools/v1/resources/school_sharing_mode.proto (package studyo.today.schools.v1.resources, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, tsEnum } from "@bufbuild/protobuf/codegenv1";

/**
 * Describes the file studyo/today/schools/v1/resources/school_sharing_mode.proto.
 */
export const file_studyo_today_schools_v1_resources_school_sharing_mode = /*@__PURE__*/
  fileDesc("CjtzdHVkeW8vdG9kYXkvc2Nob29scy92MS9yZXNvdXJjZXMvc2Nob29sX3NoYXJpbmdfbW9kZS5wcm90bxIhc3R1ZHlvLnRvZGF5LnNjaG9vbHMudjEucmVzb3VyY2VzKnwKEVNjaG9vbFNoYXJpbmdNb2RlEiMKH1NDSE9PTF9TSEFSSU5HX01PREVfVU5TUEVDSUZJRUQQABIiCh5TQ0hPT0xfU0hBUklOR19NT0RFX05PVF9TSEFSRUQQARIeChpTQ0hPT0xfU0hBUklOR19NT0RFX1NIQVJFRBACQimqAiZTdHVkeW8uVG9kYXkuU2Nob29scy5HcnBjLlYxLlJlc291cmNlc2IGcHJvdG8z");

/**
 * Describes the enum studyo.today.schools.v1.resources.SchoolSharingMode.
 */
export const SchoolSharingModeSchema = /*@__PURE__*/
  enumDesc(file_studyo_today_schools_v1_resources_school_sharing_mode, 0);

/**
 * Represents the manner in which a school is shared, if any.
 *
 * @generated from enum studyo.today.schools.v1.resources.SchoolSharingMode
 */
export const SchoolSharingMode = /*@__PURE__*/
  tsEnum(SchoolSharingModeSchema);

